"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckSubTasksPlugin = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const workflow_core_1 = require("@sierralabs/workflow-core");
const useWorkflowItem_1 = require("../../hooks/useWorkflowItem");
const StyledFormHelperText = (0, styled_components_1.default)(core_1.FormHelperText) `
  padding-left: 8px;
`;
const CheckSubTasksConfigurator = props => {
    var _a, _b, _c, _d, _e;
    const { event, condition, onChange } = props;
    const invokes = Array.isArray(event.stateNode.invoke)
        ? event.stateNode.invoke
        : event.stateNode.invoke
            ? [event.stateNode.invoke]
            : [];
    const invoke = invokes.find(invoke => invoke.src === workflow_core_1.WorkflowInvokeAction.CreateSubTasks);
    const workflowId = ((_a = invoke === null || invoke === void 0 ? void 0 : invoke.data) === null || _a === void 0 ? void 0 : _a.workflowId) || ((_c = (_b = invoke === null || invoke === void 0 ? void 0 : invoke.data) === null || _b === void 0 ? void 0 : _b.workflow) === null || _c === void 0 ? void 0 : _c.id);
    const item = (0, useWorkflowItem_1.useWorkflowItem)({ workflowId });
    const { workflow } = item || {};
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(core_1.TextField, { fullWidth: true, variant: 'outlined', select: !!workflow, disabled: !workflow, label: workflow ? 'Transition State' : 'Loading...', helperText: 'Pick a state that all subtasks must reach before transitioning.', value: ((_d = condition.params) === null || _d === void 0 ? void 0 : _d.path) || '', onChange: event => {
                    if (condition.params) {
                        condition.params.path = event.target.value;
                        onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                    }
                } }, workflow === null || workflow === void 0 ? void 0 : workflow.getAllPaths().map(path => (react_1.default.createElement(core_1.MenuItem, { key: path, value: path }, path))))),
        react_1.default.createElement(core_1.Box, { mt: 1 },
            react_1.default.createElement(core_1.FormControl, { fullWidth: true },
                react_1.default.createElement(core_1.FormControlLabel, { label: 'Partial', control: react_1.default.createElement(core_1.Switch, { color: 'primary', checked: ((_e = condition.params) === null || _e === void 0 ? void 0 : _e.partial) || false, onChange: (_, checked) => {
                            if (condition.params) {
                                condition.params.partial = checked;
                                onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                            }
                        } }) }),
                react_1.default.createElement(StyledFormHelperText, null, "If partial is enabled, at least one (1) subtask must reach the selected state before transitioning.")))));
};
const CheckSubTasksDisplay = () => {
    return react_1.default.createElement(react_1.default.Fragment, null, "Check SubTasks");
};
exports.CheckSubTasksPlugin = {
    type: 'check-subtasks',
    label: 'Check SubTasks',
    configurator: CheckSubTasksConfigurator,
    display: CheckSubTasksDisplay,
    canConfigure: event => {
        var _a, _b, _c;
        // only allow "Check SubTask" if create sub tasks action is invoked
        const invokes = Array.isArray(event.stateNode.invoke)
            ? event.stateNode.invoke
            : event.stateNode.invoke
                ? [event.stateNode.invoke]
                : [];
        const invoke = invokes === null || invokes === void 0 ? void 0 : invokes.find(invoke => invoke.src === workflow_core_1.WorkflowInvokeAction.CreateSubTasks);
        const workflowId = ((_a = invoke === null || invoke === void 0 ? void 0 : invoke.data) === null || _a === void 0 ? void 0 : _a.workflowId) || ((_c = (_b = invoke === null || invoke === void 0 ? void 0 : invoke.data) === null || _b === void 0 ? void 0 : _b.workflow) === null || _c === void 0 ? void 0 : _c.id);
        return (!!workflowId && (invoke === null || invoke === void 0 ? void 0 : invoke.src) === workflow_core_1.WorkflowInvokeAction.CreateSubTasks);
    },
    validate: () => true,
    guard: (state, params) => {
        console.log('guards: check-subtasks', state, params);
        return (0, workflow_core_1.CheckSubTasksGuard)(state.context.task, params);
    }
};
//# sourceMappingURL=CheckSubTasksPlugin.js.map